import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        text: ["Link to share", "Поделиться ссылкой"][index],
        save: ["Save", "Сохранить"][index],
        share: ["Share & Download", "Поделиться & Скачать"][index],
    };
};
